export enum SalesByItemReportTableAccessor {
  GrossTotal = 'grossTotal',
  ItemName = 'productName',
  ItemQuantity = 'quantity',
  ItemType = 'productType',
  NetTotal = 'netTotal',
}
